import React, { useEffect, useMemo, useRef } from "react";
import { useLandingHtml } from "../api/useLandingHtml";
import "./NewLandingPage.css"; // DB CSS can still override

function applyTokens(html) {
  const year = String(new Date().getFullYear());
  return (html || "").replaceAll("{{YEAR}}", year);
}

export default function LandingPageDb() {
  const { html, loading, error } = useLandingHtml();
  const containerRef = useRef(null);

  const finalHtml = useMemo(() => applyTokens(html), [html]);

  useEffect(() => {
    if (!finalHtml) return;
    const root = containerRef.current;
    if (!root) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("animate");
        });
      },
      { threshold: 0.1 }
    );

    root.querySelectorAll(".scroll-animate").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [finalHtml]);

  if (loading) return <div style={{ padding: 24 }}>Loading…</div>;
  if (error) return <div style={{ padding: 24, color: "crimson" }}>Failed to load landing.</div>;

  // We inject the WHOLE page markup from DB (including the `.lp` wrapper)
  return <div ref={containerRef} dangerouslySetInnerHTML={{ __html: finalHtml }} />;
}
